import request from '@/api/request';
const defaultRequest = request();

export function AccountRequest (trackingId) {
  return defaultRequest({
    url: 'crm/account',
    method: 'get',
    params: { trackingId }
  });
}

export function ContacsRequest (accountId) {
  return defaultRequest({
    url: 'crm/account/contacts',
    method: 'get',
    params: { accountId }
  });
}

export function CasesRequest (accountId) {
  return defaultRequest({
    url: 'crm/account/cases',
    method: 'get',
    params: { accountId }
  });
}

export function GetAllCases () {
  return defaultRequest({
    url: 'crm/case/all',
    method: 'get',
  });
}

export function GetSupporters (params) {
  return defaultRequest({
    url: 'crm/user/supporters',
    method: 'get',
    params
  });
}

export function GetProfile (email) {
  return defaultRequest({
    url: 'crm/account/profile',
    method: 'get',
    params: { email: email }
  });
}

export function CaseDispatch (data) {
  return defaultRequest({
    url: 'crm/case/dispatch',
    method: 'post',
    data
  });
}

export function UpdatePlan (data) {
  return defaultRequest({
    url: 'crm/case/updateplan',
    method: 'put',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/crm.js